// extracted by mini-css-extract-plugin
export var nav = "layout-module--nav--ma0SR";
export var nav_menu = "layout-module--nav_menu--uoKLm";
export var logo = "layout-module--logo--9Ozid";
export var hamburger = "layout-module--hamburger--h7E0E";
export var content = "layout-module--content--u4In+";
export var footer = "layout-module--footer--4b3+4";
export var emoji = "layout-module--emoji--Mxypj";
export var link = "layout-module--link--8S4u4";
export var waveAnimation = "layout-module--wave-animation--mBJvQ";